import { render, staticRenderFns } from "./perceptual_speed.config.vue?vue&type=template&id=5f64d3a6"
import script from "./perceptual_speed.config.vue?vue&type=script&lang=js"
export * from "./perceptual_speed.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports